import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { UserStatusCssClasses } from "../UsersUIHelpers";
import * as actions from "../../../_redux/users/usersActions";
import { useUsersUIContext } from "../UsersUIContext";

const selectedUsers = (entities, ids) => {
  const _users = [];
  ids.forEach((id) => {
    const user = entities.find((el) => el.id === id);
    if (user) {
      _users.push(user);
    }
  });
  return _users;
};

export function UsersUpdateStatusDialog({ show, onHide }) {
  // Users UI Context
  const usersUIContext = useUsersUIContext();
  const usersUIProps = useMemo(() => {
    return {
      ids: usersUIContext.ids,
      setIds: usersUIContext.setIds,
      queryParams: usersUIContext.queryParams,
    };
  }, [usersUIContext]);

  // Users Redux state
  const { users, isLoading } = useSelector(
    (state) => ({
      users: selectedUsers(state.users.entities, usersUIProps.ids),
      isLoading: state.users.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected users we should close modal
  useEffect(() => {
    if (!usersUIProps.ids || usersUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersUIProps.ids]);

  const [status, setStatus] = useState("active");

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updating user by ids
    dispatch(actions.updateUsersStatus(usersUIProps.ids, status)).then(
      () => {
        // refresh list after process
        dispatch(actions.fetchUsers(usersUIProps.queryParams)).then(
          () => {
            // clear selections list
            usersUIProps.setIds([]);
            // closing modal
            onHide();
          }
        );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="user-status-modal-title"
    >
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="user-status-modal-title" className="font-weight-bolder text-dark">
          Update Status for Selected Users
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="alert alert-custom alert-light-primary fade show mb-4 py-3 px-4 d-flex align-items-center" role="alert">
          <div className="alert-icon mr-3">
            <i className="fa fa-info-circle text-primary font-size-h5"></i>
          </div>
          <div className="alert-text font-size-sm text-dark font-weight-bold">
            Updating status for <span className="text-primary font-size-lg font-weight-bolder">{usersUIProps.ids.length}</span> selected users.
          </div>
        </div>

        <div className="form-group mb-2">
          <label className="font-weight-bold text-dark font-size-sm mb-2">
            Change Status To
          </label>
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={updateStatus}
          className="btn btn-primary font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Updating...
            </>
          ) : (
            "Update Status"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
